import { Checkbox } from 'antd';
import React from 'react';

const SingleCheckboxInput = props => {
    const { def, data, onChange, state } = props;

    const chk = data === 'True';

    return <Checkbox
        data-input='singlecheckboxinput_de'
        checked={chk}
        onChange={(e) => { if (!state.readonly) onChange(def.dataKey, !chk ? 'True' : null) }}
    />
}

export default SingleCheckboxInput;
